import { useQuery } from '@zoomcatalog/query-client';
import { AxiosError } from 'axios';

type QueryWrapperContext<T> = {
  options: {
    queryKey: string;
    queryFn(): Promise<T>;
    enabled?: boolean;
  };
  handlers?: {
    onSuccess: (data: T | undefined) => void;
  };
};
export function useQueryWrapper<T>(context: QueryWrapperContext<T>) {
  return useQuery<T, AxiosError>(context.options.queryKey, {
    queryFn: () => context.options.queryFn?.(),
    onSuccess(data) {
      context?.handlers?.onSuccess(data);
    },
    enabled: context?.options?.enabled ?? true,
    staleTime: Infinity,
    refetchOnMount: false,
  });
}
